<template>
  <div
    class="full-width full-height overflow-hidden"
    style="position: relative;"
    :class="{
      'q-mr-md': shadow,
      [`bg-${backgroundColor}`]: backgroundColor,
      [`shadow-${shadow}`]: backgroundColor || backgroundColorHex
    }"
    :style="{
      'background-color': backgroundColorHex,
      'border-radius': `${borderRadius}px`
    }"
    data-test-id="explore-poster"
    @mouseenter="showButtons = !$q.platform.is.mobile"
    @mouseleave="showButtons = false"
    @click.stop="selectMovie(movie)"
  >
    <component
      :is="isInsideSwiper ? 'div' : 'q-img'"
      width="100%"
      :style="{
        'border-radius': cleanImageOnPosters && ((showMovieShowingStatusOnPosters && movie.displayMetaData.classes) || (showTitleClass && movie.titleClass) || (backgroundColor || backgroundColorHex)) ? `${borderRadius}px ${borderRadius}px 0 0` : `${borderRadius}px`,
        height: !!posterHeight ? posterHeight : undefined,
        'max-width': !!imageMaxWidth ? imageMaxWidth : undefined
      }"
      :class="{
        [`shadow-${shadow}`]: !backgroundColor && !backgroundColorHex,
        'q-mx-auto': !!imageMaxWidth,
        'q-mb-lg': !!imageMaxWidth
      }"
      :ratio="isInsideSwiper ? undefined : getBannerOrPosterAspectRatio"
      :src="isInsideSwiper? undefined : useBanner ? movie.bannerImageUrl : movie.posterImageUrl"
    >
      <img
        v-if="isInsideSwiper"
        style="width: 100%;"
        :src="useBanner ? movie.bannerImageUrl : movie.posterImageUrl"
      >
      <div
        v-if="!cleanImageOnPosters || isFeatured"
        class="absolute-bottom"
        style="padding: 0; background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));"
      >
        <div
          v-if="!cleanImageOnPosters && (showMovieTitleOnPosters || displayMovieGenre || displayMovieRating || (showMovieShowingStatusOnPosters && movie.displayMetaData.classes) || (showTitleClass && movie.titleClass))"
          class="q-pa-md"
          :class="{ 'row justify-between items-start': showMovieCTAButton(movie) }"
          style="background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));"
        >
          <div
            :class="{
              'col': showMovieCTAButton(movie) && !hasTextCentred,
              'col-12': showMovieCTAButton(movie) && hasTextCentred,
            }"
          >
            <div
              v-if="showMovieTitleOnPosters"
              class="text-h6 text-white q-mb-sm"
              :class="{
                'ellipsis': hasTextWrapped,
                'text-center': hasTextCentred,
              }"
              style="text-shadow: 0 1px 8px #0003, 0 3px 4px #00000024, 0 3px 3px -2px #0000001f; line-height: 1;"
              :style="{ 'font-size': getFontSize }"
            >
              {{ movie.name }}
            </div>
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="showMovieSynopsis"
              class="q-mb-sm"
              :class="{
                'ellipsis-lines': truncatedMovieSynopsis,
                'text-center': hasTextCentred,
                'text-white': posterTextLight,
                'text-dark': !posterTextLight,
                'q-px-md': (backgroundColor || backgroundColorHex) && cleanImageOnPosters
              }"
              style="line-height: 1.2;"
              :style="{
                'font-size': `${fontSize*0.8}px`,
                '-webkit-line-clamp': truncatedMovieSynopsis ? isMobileView ? mobileTruncatedLineCount : truncatedLineCount : undefined
              }"
              v-html="movie.synopsisWithBreaks"
            />
          <!-- eslint-enable vue/no-v-html -->
          </div>
          <q-btn
            v-if="showMovieCTAButton(movie) && !hasTextCentred"
            class="col-auto q-ml-sm text-weight-bold"
            :outline="buttonType === BUTTON_TYPES.OUTLINE"
            :flat="buttonType === BUTTON_TYPES.FLAT"
            :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
            :color="buttonColor !== 'custom' ? buttonColor : undefined"
            :style="{
              'background-color': (buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom' ? buttonColorHex : undefined,
              'border-radius': buttonBorderRadius === 0 ? '0' : `${buttonBorderRadius}px`,
              'color': (buttonType === BUTTON_TYPES.FLAT || buttonType === BUTTON_TYPES.OUTLINE) && buttonColor === 'custom' ? buttonColorHex : undefined,
              'font-size': `${fontSize*0.7}px`
            }"
            :text-color="textColor"
            :label="buttonLabel"
            padding="xs sm"
          />
          <div
            v-if="(displayMovieRating || displayMovieGenre) || (featuredShowingBadges && featuredShowingBadges.length > 0)"
            class="text-h6 text-white"
            :class="{
              'ellipsis': hasTextWrapped,
              'text-center': hasTextCentred,
              'col-12': showMovieCTAButton(movie),
              'row justify-between': featuredShowingBadges && featuredShowingBadges.length > 0 && !hasTextCentred
            }"
            style="line-height: 1.2;"
            :style="{ 'font-size': getFontSize }"
          >
            <div class="col">
              <template v-if="(displayMovieRating || displayMovieGenre)">
                <rated
                  v-if="displayMovieRating"
                  :rated="movie.rating"
                  :rating-reason="movie.ratingReason"
                  :outline="false"
                  :color="'secondary'"
                  :font-size="fontSize*0.6"
                  :border-radius="borderRadius"
                  :is-font-size-responsive="isFontSizeResponsive"
                  :display-rating-reason="displayRatingReason"
                  :highlight-r-rated="highlightRRated"
                  :disable-official-symbol="disableOfficialSymbol"
                  dense
                  class="q-mr-sm q-ml-none"
                />
                <template v-if="displayMovieRating && movie.ratingReason && displayRatingReason">
                  <span
                    class="q-px-xs"
                  >
                    &middot;
                  </span>
                  <small>
                    {{ movie.ratingReason }}
                  </small>
                </template>
                <template v-if="displayMovieGenre">
                  <span
                    v-if="displayMovieRating"
                    class="q-px-xs"
                  >
                    &middot;
                  </span>
                  <small v-if="movie.genre">
                    {{ movie.genre }}
                  </small>
                </template>
              </template>
              <template
                v-if="featuredShowingBadges && featuredShowingBadges.length > 0 && hasTextCentred"
              >
                <span
                  v-if="displayMovieRating || displayMovieGenre"
                  class="q-px-xs"
                >
                  &middot;
                </span>
                <showing-badge
                  v-for="(showingBadge, index) in featuredShowingBadges"
                  :key="showingBadge"
                  size="md"
                  class="col-auto bg-transparent"
                  dense
                  outline
                  solid
                  :color="posterTextLight ? 'white' : 'black'"
                  :showing-badge="showingBadge"
                >
                  <span
                    v-if="index !== 0"
                    class="q-px-xs"
                  >
                    &middot;
                  </span>
                </showing-badge>
              </template>
            </div>
            <div
              v-if="featuredShowingBadges && featuredShowingBadges.length > 0 && !hasTextCentred"
              class="col-auto"
            >
              <showing-badge
                v-for="showingBadge in featuredShowingBadges"
                :key="showingBadge"
                size="md"
                class="col-auto"
                dense
                outline
                solid
                :color="posterTextLight ? 'white' : 'black'"
                :showing-badge="showingBadge"
              />
            </div>
          </div>

          <q-btn
            v-if="showMovieCTAButton(movie) && hasTextCentred"
            class="col-auto text-weight-bold q-mx-auto q-mt-sm"
            :outline="buttonType === BUTTON_TYPES.OUTLINE"
            :flat="buttonType === BUTTON_TYPES.FLAT"
            :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
            :color="buttonColor !== 'custom' ? buttonColor : undefined"
            :style="{
              'background-color': (buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom' ? buttonColorHex : undefined,
              'border-radius': buttonBorderRadius === 0 ? '0' : `${buttonBorderRadius}px`,
              'color': (buttonType === BUTTON_TYPES.FLAT || buttonType === BUTTON_TYPES.OUTLINE) && buttonColor === 'custom' ? buttonColorHex : undefined,
              'font-size': `${fontSize*0.7}px`
            }"
            :text-color="textColor"
            :label="buttonLabel"
            padding="xs sm"
          />
        </div>
        <template
          v-if="(!cleanImageOnPosters && ((showMovieShowingStatusOnPosters && movie.displayMetaData.classes) || (showTitleClass && movie.titleClass))) || hasFeaturedTitleClass"
        >
          <q-badge
            v-if="(showTitleClass && movie.titleClass)|| hasFeaturedTitleClass"
            dense
            class="text-weight-bold justify-center inset-shadow full-width"
            :class=" movie.titleClass.color ? 'text-white' : 'text-primary bg-white'"
            :style="{ 'background-color': movie.titleClass.color ? movie.titleClass.color : undefined }"
            style="line-height: auto; min-height: auto; border-radius: 0; padding: 8px; "
          >
            {{ movie.titleClass.name }}
          </q-badge>
          <q-badge
            v-if="showMovieShowingStatusOnPosters && movie.displayMetaData.classes"
            dense
            class=" text-white text-weight-bold justify-center inset-shadow full-width"
            :class="{
              'bg-secondary': !movie.displayMetaData.classes.includes('showing-status-now-playing '),
              'bg-primary': movie.displayMetaData.classes.includes('showing-status-now-playing ') && !movie.displayMetaData.classes.includes('leaves-soon'),
              'bg-negative': movie.displayMetaData.classes.includes('showing-status-now-playing ') && movie.displayMetaData.classes.includes('leaves-soon')
            }"
            style="line-height: auto; min-height: auto; border-radius: 0; padding: 8px; "
          >
            <template
              v-if="movie.displayMetaData.classes.includes('showing-status-now-playing ')"
            >
              <template
                v-if="movie.displayMetaData.classes.includes('leaves-soon') && !movie.displayMetaData.classes.includes('last-day-tomorrow') && !movie.displayMetaData.classes.includes('last-day-today')"
              >
                {{ $t('time.leavesSoon') }}
              </template>
              <template
                v-else-if="movie.displayMetaData.classes.includes('leaves-soon') && movie.displayMetaData.classes.includes('last-day-today')"
              >
                {{ $t('time.endsToday') }}
              </template>
              <template
                v-else-if="movie.displayMetaData.classes.includes('leaves-soon') && movie.displayMetaData.classes.includes('last-day-tomorrow')"
              >
                {{ $t('time.endsTomorrow') }}
              </template>
              <template
                v-else
              >
                {{ $t('movie.nowPlaying') }}
              </template>
            </template>

            <template
              v-else
            >
              {{ $t('movie.comingSoon') }}
            </template>
          </q-badge>
        </template>
      </div>
    </component>
    <div
      v-if="cleanImageOnPosters && ((showMovieShowingStatusOnPosters && movie.displayMetaData.classes) || (showTitleClass && movie.titleClass))"
      class="full-width column shadow-1 overflow-hidden"
      :style="{ 'border-radius': `0 0 ${borderRadius}px ${borderRadius}px` }"
    >
      <q-badge
        v-if="showTitleClass && movie.titleClass"
        dense
        class="text-weight-bold justify-center inset-shadow"
        :class=" movie.titleClass.color ? 'text-white' : 'text-primary bg-white'"
        :style="{ 'background-color': movie.titleClass.color ? movie.titleClass.color : undefined }"
        style="line-height: auto; min-height: auto; border-radius: 0; padding: 8px; "
      >
        {{ movie.titleClass.name }}
      </q-badge>
      <q-badge
        v-if="showMovieShowingStatusOnPosters && movie.displayMetaData.classes"
        dense
        class=" text-white text-weight-bold justify-center inset-shadow"
        :class="{
          'bg-secondary': !movie.displayMetaData.classes.includes('showing-status-now-playing '),
          'bg-primary': movie.displayMetaData.classes.includes('showing-status-now-playing ') && !movie.displayMetaData.classes.includes('leaves-soon'),
          'bg-negative': movie.displayMetaData.classes.includes('showing-status-now-playing ') && movie.displayMetaData.classes.includes('leaves-soon')
        }"

        style="line-height: auto; min-height: auto; border-radius: 0; padding: 8px; "
      >
        <template
          v-if="movie.displayMetaData.classes.includes('showing-status-now-playing ')"
        >
          <template
            v-if="movie.displayMetaData.classes.includes('leaves-soon') && !movie.displayMetaData.classes.includes('last-day-tomorrow') && !movie.displayMetaData.classes.includes('last-day-today')"
          >
            {{ $t('time.leavesSoon') }}
          </template>
          <template
            v-else-if="movie.displayMetaData.classes.includes('leaves-soon') && movie.displayMetaData.classes.includes('last-day-today')"
          >
            {{ $t('time.endsToday') }}
          </template>
          <template
            v-else-if="movie.displayMetaData.classes.includes('leaves-soon') && movie.displayMetaData.classes.includes('last-day-tomorrow')"
          >
            {{ $t('time.endsTomorrow') }}
          </template>
          <template
            v-else
          >
            {{ $t('movie.nowPlaying') }}
          </template>
        </template>

        <template
          v-else
        >
          {{ $t('movie.comingSoon') }}
        </template>
      </q-badge>
    </div>

    <q-btn
      v-if="movie.trailerYoutubeId && showTrailerButtonOnPosters"
      square
      color="primary"
      :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'black'"
      size="sm"
      padding="sm"
      class="watch-trailer-btn absolute-top-left shadow-6 row"
      icon="play_arrow"
      style="z-index: 2;"
      :style="'border-radius: ' + borderRadius + 'px;'"
      @click.stop="playTrailer(movie.trailerYoutubeId)"
    />

    <div
      v-if="showUserButtons || showMovieComingSoonDate"
      class="absolute-top-right row"
    >
      <movie-list-buttons
        v-if="showUserButtons"
        :class="$q.screen.lt.md ? 'q-pa-none' : 'q-px-xs q-py-none'"
        class="col"

        :active-only="false"
        :movie="movie"
        :hide-rating="movie.future"
        :hide-favorite="movie.future"
        :size="(widthMode === 'Full Width' || $q.screen.lt.md || isPhonePreview ) && !showComingSoonDate ? 'md' : 'sm'"
        icon-only
        gutter-size="none"
        use-dark-mode
      />
      <span
        v-if="showMovieComingSoonDate && (movieFirstShowingDate || movieReleaseDate)"
        class="bg-secondary q-px-sm text-right q-ml-auto col-auto text-weight-bold"
        :class="{
          'text-white': $isColorDark(currentSite.secondaryColor),
          'text-dark': !$isColorDark(currentSite.secondaryColor),
          'q-py-xs': $q.screen.gt.xs,
          'q-py-sm': $q.screen.lt.sm
        }"
      >
        <template v-if="movieFirstShowingDate">{{ movieFirstShowingDate }}</template>
        <template v-else>{{ movieReleaseDate }}</template>
      </span>
    </div>
    <div
      v-if="cleanImageOnPosters && ( showMovieTitleOnPosters || displayMovieRating || displayMovieGenre || showMovieSynopsis)"
      class="q-pt-md movie-info"
      :class="{
        'row justify-between items-start': showMovieCTAButton(movie),
        'q-pb-sm': !$register
      }"
      :style="{ 'min-height': cleanImageOnPosters ?`${maxBannerHeight}px` : undefined }"
    >
      <div
        :class="{
          'col': showMovieCTAButton(movie) && !hasTextCentred,
          'col-12': showMovieCTAButton(movie) && hasTextCentred
        }"
      >
        <div
          v-if="showMovieTitleOnPosters"
          class="text-h6 q-mb-sm"
          :class="{
            'ellipsis': hasTextWrapped,
            'text-center': hasTextCentred,
            'text-white': posterTextLight,
            'text-dark': !posterTextLight,
            'q-px-md': (backgroundColor || backgroundColorHex) && cleanImageOnPosters
          }"
          style="line-height: 1.2;"
          :style="{ 'font-size': getFontSize }"
        >
          {{ movie.name }}
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="showMovieSynopsis"
          class="q-mb-sm"
          :class="{
            'ellipsis-lines': truncatedMovieSynopsis,
            'text-center': hasTextCentred,
            'text-white': posterTextLight,
            'text-dark': !posterTextLight,
            'q-px-md': (backgroundColor || backgroundColorHex) && cleanImageOnPosters
          }"
          style="line-height: 1.2;"
          :style="{
            'font-size': `${fontSize*0.8}px`,
            '-webkit-line-clamp': truncatedMovieSynopsis ? isMobileView ? mobileTruncatedLineCount : truncatedLineCount : undefined
          }"
          v-html="movie.synopsisWithBreaks"
        />
      <!-- eslint-enable vue/no-v-html -->
      </div>
      <q-btn
        v-if="showMovieCTAButton(movie) && !hasTextCentred"
        class="col-auto text-weight-bold q-mx-sm"
        :outline="buttonType === BUTTON_TYPES.OUTLINE"
        :flat="buttonType === BUTTON_TYPES.FLAT"
        :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
        :color="buttonColor !== 'custom' ? buttonColor : undefined"
        :style="{
          'background-color': (buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom' ? buttonColorHex : undefined,
          'border-radius': buttonBorderRadius === 0 ? '0' : `${buttonBorderRadius}px`,
          'color': (buttonType === BUTTON_TYPES.FLAT || buttonType === BUTTON_TYPES.OUTLINE) && buttonColor === 'custom' ? buttonColorHex : undefined,
          'font-size': `${fontSize*0.7}px`
        }"
        :text-color="textColor"
        :label="buttonLabel"
        padding="xs sm"
      />

      <div
        v-if="(displayMovieRating || displayMovieGenre) || (featuredShowingBadges && featuredShowingBadges.length > 0)"
        class="text-h6 q-gutter-xs col"
        :class="{
          'ellipsis': hasTextWrapped,
          'text-center q-px-md': hasTextCentred,
          'text-white': posterTextLight,
          'text-dark': !posterTextLight,
          'col-12': showMovieCTAButton(movie),
          'row justify-between': featuredShowingBadges && featuredShowingBadges.length > 0 && !hasTextCentred,
          'q-pl-md': backgroundColor || backgroundColorHex
        }"
        style="line-height: 1;"
        :style="{ 'font-size': getFontSize }"
      >
        <div
          class="col"
        >
          <template v-if="displayMovieRating || displayMovieGenre">
            <small v-if="displayMovieRating">
              <rated
                v-if="movie.rating"
                :rated="movie.rating"
                :rating-reason="movie.ratingReason"
                :outline="false"
                :color="'transparent'"
                :text-color=" posterTextLight ? 'white' : 'black'"
                :font-size="fontSize*0.6"
                :border-radius="borderRadius"
                :is-font-size-responsive="isFontSizeResponsive"
                :display-rating-reason="displayRatingReason"
                :highlight-r-rated="highlightRRated"
                :disable-official-symbol="disableOfficialSymbol"
                dense
                class="no-padding q-ml-none"
              />
            </small>
            <template v-if="movie.rating && movie.ratingReason && displayRatingReason">
              <span
                class="q-px-xs"
              >
                &middot;
              </span>
              <small>
                {{ movie.ratingReason }}
              </small>
            </template>
            <template v-if="displayMovieGenre">
              <span
                v-if="displayMovieRating"
                class="q-px-xs"
              >
                &middot;
              </span>
              <small v-if="movie.genre">
                {{ movie.genre }}
              </small>
            </template>
          </template>
          <template
            v-if="featuredShowingBadges && featuredShowingBadges.length > 0 && hasTextCentred"
          >
            <span
              v-if="displayMovieGenre || displayMovieRating"
              class="q-px-xs"
            >
              &middot;
            </span>
            <showing-badge
              v-for="(showingBadge, index) in featuredShowingBadges"
              :key="showingBadge"
              size="md"
              class="col-auto bg-transparent"
              dense
              outline
              solid
              :color="posterTextLight ? 'white' : 'black'"
              :showing-badge="showingBadge"
            >
              <span
                v-if="index !== 0"
                class="q-px-xs"
              >
                &middot;
              </span>
            </showing-badge>
          </template>
        </div>
        <div
          v-if="featuredShowingBadges && featuredShowingBadges.length > 0 && !hasTextCentred"
          class="col-auto"
        >
          <showing-badge
            v-for="showingBadge in featuredShowingBadges"
            :key="showingBadge"
            size="md"
            class="col-auto"
            dense
            outline
            :color="posterTextLight ? 'white' : 'black'"
            :showing-badge="showingBadge"
          />
        </div>
      </div>

      <q-btn
        v-if="showMovieCTAButton(movie) && hasTextCentred"
        class="col-auto text-weight-bold q-mx-auto q-my-sm"
        :outline="buttonType === BUTTON_TYPES.OUTLINE"
        :flat="buttonType === BUTTON_TYPES.FLAT"
        :unelevated="buttonType === BUTTON_TYPES.UNELEVATED"
        :color="buttonColor !== 'custom' ? buttonColor : undefined"
        :style="{
          'background-color': (buttonType === BUTTON_TYPES.STANDARD || buttonType === BUTTON_TYPES.UNELEVATED) && buttonColor === 'custom' ? buttonColorHex : undefined,
          'border-radius': buttonBorderRadius === 0 ? '0' : `${buttonBorderRadius}px`,
          'color': (buttonType === BUTTON_TYPES.FLAT || buttonType === BUTTON_TYPES.OUTLINE) && buttonColor === 'custom' ? buttonColorHex : undefined,
          'font-size': `${fontSize*0.7}px`
        }"
        :text-color="textColor"
        :label="buttonLabel"
        padding="xs sm"
      />
    </div>
    <trailer-player-dialog
      ref="trailerDialog"
      :trailer-youtube-id="trailerYoutubeId"
      :is-phone-preview="isPhonePreview"
    />
  </div>
</template>

<script>
import { IsoDate } from 'src/models/Model'
import { BUTTON_TYPES } from 'src/models/page/Section'
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import MovieListButtons from 'src/modules/consumer/components/MovieListButtons'
import Rated from 'src/modules/consumer/components/Rated'
import TrailerPlayerDialog from 'src/modules/consumer/components/TrailerPlayerDialog'

export default {
  name: 'ExplorePoster',
  configuration: ['currentSite'],
  components: {
    MovieListButtons,
    Rated,
    ShowingBadge,
    TrailerPlayerDialog
  },
  props: {
    widthMode: {
      type: String,
      required: false,
      default: 'Full Width'
    },
    movie: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      required: false,
      default: null
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 0
    },
    showUserButtons: {
      type: Boolean,
      required: false,
      default: true
    },
    shadow: {
      type: Number,
      required: false,
      default: 0
    },
    useBanner: {
      type: Boolean,
      required: false,
      default: false
    },
    dragging: {
      type: Boolean,
      required: false,
      default: false
    },
    showTrailerButtonOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    cleanImageOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    exploreUsingDarkMode: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieTitleOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieRating: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieGenre: {
      type: Boolean,
      required: false,
      default: false
    },
    fontSize: {
      type: Number,
      required: false,
      default: 20
    },
    hasTextWrapped: {
      type: Boolean,
      required: false,
      default: true
    },
    hasTextCentred: {
      type: Boolean,
      required: false,
      default: false
    },
    showMovieShowingStatusOnPosters: {
      type: Boolean,
      required: false,
      default: false
    },
    showTitleClass: {
      type: Boolean,
      required: false,
      default: false
    },
    posterBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    posterBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    posterFeaturedBackgroundColor: {
      type: String,
      required: false,
      default: null
    },
    posterFeaturedBackgroundColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    showMovieSynopsis: {
      type: Boolean,
      required: false,
      default: false
    },
    truncatedMovieSynopsis: {
      type: Boolean,
      required: false,
      default: true
    },
    showComingSoonDate: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonLabel: {
      type: String,
      required: false,
      default: null
    },
    buttonType: {
      type: String,
      required: false,
      default: BUTTON_TYPES.OUTLINE
    },
    buttonColor: {
      type: String,
      required: false,
      default: null
    },
    buttonColorHex: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    buttonBorderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    isFeatured: {
      type: Boolean,
      required: false,
      default: false
    },
    hasFeaturedTitleClass: {
      type: Boolean,
      required: false,
      default: false
    },
    featuredShowingBadges: {
      type: [ShowingBadge],
      required: false,
      default: null
    },
    isPhonePreview: {
      type: Boolean,
      required: false,
      default: false
    },
    isMobileView: {
      type: Boolean,
      required: false,
      default: false
    },
    posterPadding: {
      type: Number,
      required: false,
      default: 0
    },
    isFontSizeResponsive: {
      type: Boolean,
      required: false,
      default: false
    },
    displayRatingReason: {
      type: Boolean,
      required: false,
      default: false
    },
    posterHeight: {
      type: String,
      required: false,
      default: null
    },
    imageMaxWidth: {
      type: String,
      required: false,
      default: null
    },
    isInsideSwiper: {
      type: Boolean,
      required: false,
      default: false
    },
    disableOfficialSymbol: {
      type: Boolean,
      required: false,
      default: false
    },
    highlightRRated: {
      type: Boolean,
      required: false,
      default: false
    },
    truncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    },
    mobileTruncatedLineCount: {
      type: Number,
      required: false,
      default: 3
    }

  },

  data () {
    return {
      showButtons: false,
      trailerYoutubeId: null,
      maxBannerHeight: null
    }
  },
  computed: {
    backgroundColor () {
      if (!this.cleanImageOnPosters) return
      if (this.isFeatured && this.posterFeaturedBackgroundColor) {
        if (this.posterFeaturedBackgroundColor !== 'custom') return this.posterFeaturedBackgroundColor

        return undefined
      }

      if (this.posterBackgroundColor && this.posterBackgroundColor !== 'custom') return this.posterBackgroundColor

      return undefined
    },
    backgroundColorHex () {
      if (!this.cleanImageOnPosters) return
      if (this.isFeatured && this.posterFeaturedBackgroundColor === 'custom') return this.posterFeaturedBackgroundColorHex

      if (this.posterBackgroundColor === 'custom') return this.posterBackgroundColorHex

      return undefined
    },
    posterTextLight () {
      if (!this.cleanImageOnPosters) return true
      if (!this.backgroundColor && !this.backgroundColorHex) return !!this.exploreUsingDarkMode
      let backgroundColorHex
      if (this.backgroundColor) {
        backgroundColorHex = this.$getSiteColorHex(this.currentSite, this.backgroundColor)
      } else {
        backgroundColorHex = this.backgroundColorHex
      }
      if (!backgroundColorHex) return false
      return this.$isColorDark(backgroundColorHex)
    },
    textColor () {
      if (this.buttonType === BUTTON_TYPES.OUTLINE || this.buttonType === BUTTON_TYPES.FLAT || !this.buttonColor) return
      let buttonColorHex
      if (this.buttonColor === 'custom') {
        buttonColorHex = this.buttonColorHex
      } else {
        buttonColorHex = this.$getSiteColorHex(this.currentSite, this.buttonColor)
      }
      if (!buttonColorHex) return false
      return this.$isColorDark(buttonColorHex) ? 'white' : 'black'
    },
    getBannerOrPosterAspectRatio () {
      if (!this.useBanner) return 0.6667
      if (this.posterPadding) return 1.31 + (this.posterPadding * 0.01)
      return 1.333
    },
    displayMovieRating () {
      return (this.movie.rating && this.showMovieRating)
    },
    displayMovieGenre () {
      return this.movie.genre && this.showMovieGenre
    },
    getFontSize () {
      if (this.isFontSizeResponsive) return this.$isLandscapeView() ? `${this.fontSize}vw` : `${this.fontSize}vh`

      return `${this.fontSize}px`
    },
    movieReleaseDate () {
      // If the movie has a dateOfFirstShowing and overrideDateOfFirstShowing is true, use the dateOfFirstShowing
      if (this.movie.dateOfFirstShowing && !!this.movie.overrideDateOfFirstShowing) return this.movie.dateOfFirstShowing.i18n('monthDay')
      return this.movie?.releaseDate?.i18n('monthDay')
    },
    movieFirstShowingDate () {
      if (!this.movie.datesWithPublicShowing || this.movie.datesWithPublicShowing.length === 0) return
      return this.$d(new Date(this.firstShowingDate(this.movie.datesWithPublicShowing[0])), 'monthDay')
    },
    showMovieComingSoonDate () {
      // A movie is "coming soon" if:
      // 1. It doesn't have the "now-playing" class, AND
      // 2. Either its first showing date is in the future OR it's explicitly marked for inclusion
      const isNotNowPlaying = !this.movie.displayMetaData?.classes.includes('showing-status-now-playing ')
      const now = new Date()
      const isNowPlaying = this.movie.dateOfFirstShowing && now >= this.movie.dateOfFirstShowing
      const isExplicitlyIncluded = !!this.movie.includeInComingSoon
      const isComingSoon = isNotNowPlaying && !isNowPlaying && isExplicitlyIncluded
      return this.showComingSoonDate && isComingSoon
    }
  },
  created () {
    _.extend(this, { BUTTON_TYPES })
  },
  mounted () {
    if (!this.$consumer && this.cleanImageOnPosters) {
      this.$nextTick(this.matchHeight)
    }
  },
  methods: {
    selectMovie (movie) {
      if (this.dragging) return

      let route = movie.pagePath
      if (this.date) {
        route += `?date=${this.date.substr(0, 10)}`
      }
      this.$router.push(route)
    },
    playTrailer (playTrailer) {
      if (playTrailer == null) return
      if (playTrailer !== null) {
        this.trailerYoutubeId = playTrailer
        this.$refs.trailerDialog.show()
      }
    },

    showMovieCTAButton (movie) {
      return !!this.buttonLabel && movie.datesWithPublicShowing?.length
    },
    firstShowingDate (date) {
      return IsoDate.parse(date).inTimeZone(this.currentSite?.timeZone).format()
    },
    matchHeight () {
      // fix button alignment issue
      const bannerInfoBlocks = document.querySelectorAll('.movie-info')
      const heightDataSet = []
      _.forEach(bannerInfoBlocks, (bannerInfoBlock) => {
        const height = bannerInfoBlock.getBoundingClientRect().height
        heightDataSet.push(height)
      })
      const highest = Math.max(...heightDataSet)
      this.maxBannerHeight = highest
    }
  },
  context: ['currentUser']
}
</script>

<style lang="scss" scoped>
small {
 font-size: 68%;

}
</style>
